class AuthCtrl {
  constructor(PROVIDERS, AuthService, FEService, $stateParams, $uibModal, $scope, $window, firebase) {
    'ngInject';
    this.PROVIDERS = PROVIDERS;
    this.AuthService = AuthService;
    this.FEService = FEService;
    this.loginOptions = {
      successState: "app.form-builder",
      successStateParams: {},
      title: `Please Login`,
      canChangeProvider: true
    };
    this.$stateParams = $stateParams;
    this.$uibModal = $uibModal;
    this.$scope = $scope;
    this.$window = $window;
    this.firebase = firebase;
    this.provider = null;
  }

  async $onInit() {

    this.provider = this.PROVIDERS[this.$stateParams.provider || "Quick Base"];
    this.loginOptions.validationErrorMessage = this.$stateParams?.validationErrorMessage;

    this.firebase.auth().onAuthStateChanged((user) => {
      if (!user && !this.provider && !this.modal) {
        this.modal = this.$uibModal.open({
          template: `<provider-picker></provider-picker>`,
          backdrop: 'static',
          keyboard: false,
          size: 'sm',
          scope: this.$scope
        }).result.catch(function(res) {
          if (!(res === '$uibUnscheduledDestruction')) {
            throw res;
          }
        });
      }
    });
  }
}

export default {
  bindings: {
  },
  templateUrl: "user/auth/auth.component.html",
  controller: AuthCtrl
}